/**
 * @license Copyright (c) 2023-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

// To avoid "Cannot access 'plugins' before initialization" (due to `presets`), let's import it directly.
import { plugins } from '../../constants/plugins';
import type { ViewPlugin } from '../../types/ViewPlugin';

export function getPluginByClassName( plugin: string ): ViewPlugin {
	return plugins.find( entry => entry.className === plugin )!;
}
